export enum LivestreamRoutePath {
    Livestreams = '/livestreams',
    Detail = '/livestreams/:id',
    Join = '/livestreams/join/:id',
    Create = '/livestreams/create',
    Edit = '/livestreams/edit/:id',
    Summary = '/livestreams/summary/:id'
}
